<template>
  <a-card :bordered="false" :title="title">
    <a-alert v-if="names">
      <span slot="message"
        ><p>当前选择：</p>
        {{ names }} <a @click="onCancelSelect">取消</a></span
      >
    </a-alert>
    <a-tree
      :checkable="false"
      :tree-data="treeData"
      :replaceFields="replaceFields"
      @select="handleSelect"
    ></a-tree>
  </a-card>
</template>
<script>
//api
import { findPageNotLog } from "@/api/base/tree/manager";
import { getSelectName } from "@/utils/treeTypeUtil";
import { upSort } from "@components/_util/util";

export default {
  props: {
    title: {
      type: String,
      default: "分类列表"
    }
  },
  data() {
    return {
      //tree
      // 展示当前选择名称
      names: "",
      treeData: [],
      replaceFields: { children: "jtypes", title: "name", key: "id" }
    };
  },

  mounted() {
    this.initData();
  },

  methods: {
    //初始化数据
    initData() {
      findPageNotLog().then(res => {
        if (res.resultCode === 1) {
          upSort(res.result);
          this.treeData = res.result;
        } else {
          this.$notification.error({
            message: res.message
          });
        }
      });
    },

    handleSelect(key) {
      console.log("key", key);
      let id = key.toString();
      this.names = getSelectName(this.treeData, id);
      this.$emit("handleClick", id, this.treeData);
    },

    // 取消选择
    onCancelSelect() {
      this.handleSelect([]);
      this.$emit("ceshi");
    }
  }
};
</script>
<style></style>
